// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%280, 0, 0, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Qatar-style dark header */
.root-header {
  background: radial-gradient(circle at 0% 0%, rgba(7, 255, 169, 0.18), transparent 55%),
              radial-gradient(circle at 80% 0%, rgba(31, 124, 80, 0.25), transparent 60%),
              #101413;
  padding: 0.75rem 1.5rem;
  border-bottom: 1px solid rgba(172, 203, 195, 0.18);
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.75rem;
  position: relative;
  z-index: 1000;
  color: #e5f6f2;
  backdrop-filter: blur(18px);
}

/* Sidebar toggle button */
.sidebar-toggle {
  background: none;
  border: none;
  outline: transparent;
  color: #e5f6f2;
  padding: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;
}

.sidebar-toggle:hover {
  transform: scale(1.1);
}

/* Mobile menu button */
.mobile-menu-button {
  background: none;
  border: none;
  color: #e5f6f2;
  padding: 0.5rem;
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

/* Search container */
.search-container {
  flex: 1 1;
  min-width: 200px;
  max-width: 600px;
  margin: 0;
}

.search-container input {
  color: var(--color-sage) !important;
  background-color: rgba(16, 20, 19, 0.6) !important;
  border: 1px solid rgba(172, 203, 195, 0.3) !important;
}

.search-container input::placeholder {
  color: var(--color-sage) !important;
  opacity: 0.8;
}

.search-container input:focus {
  border-color: var(--color-mint) !important;
  box-shadow: 0 0 0 0.2rem rgba(7, 255, 169, 0.25) !important;
}

.search-container.mobile-visible {
  display: block;
  width: 100%;
  order: 3;
  margin: 0;
}

.inputSearch {
  position: relative;
  width: 100%;
}

/* Mobile search toggle */
.mobile-search-toggle {
  background: none;
  border: none;
  color: var(--color-sage);
  margin: 0;
}

/* Header right elements */
.header-right-elements {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  color: var(--color-sage);
}

/* Notification */
.notification-wrapper {
  position: relative;
  cursor: pointer;
  padding: 0.5rem;
}

.notification-badge {
  position: absolute;
  top: 0;
  right: 0;
  color: white;
  background-color: var(--color-mint) !important;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.65rem;
  font-weight: bold;
  background: #07ffa9;
  box-shadow: 0 0 12px rgba(7, 255, 169, 0.9);
}

/* Language selector */
.lang-switch {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: var(--color-sage) !important;
}

.lang-switch span {
  color: var(--color-sage) !important;
}

.language-flag {
  width: 36px;
  height: 24px;
  border-radius: 25%;
  overflow: hidden;
  box-shadow: 0 0 0 1px rgba(172, 203, 195, 0.4);
}

.language-flag img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Header divider */
.header-divider {
  height: 24px;
  width: 1px;
  background-color: rgba(172, 203, 195, 0.3);
  margin: 0;
}

/* Profile dropdown */
.profile-dropdown {
  margin: 0;
}

/* Dropdown menu styling */
.profile-dropdown .dropdown-menu {
  background-color: var(--color-dark);
  border: 1px solid rgba(172, 203, 195, 0.3);
  color: var(--color-sage);
}

.profile-dropdown .dropdown-item {
  color: var(--color-sage);
}

.profile-dropdown .dropdown-item:hover {
  background-color: rgba(16, 20, 19, 0.6);
  color: var(--color-sage);
}

.profile-dropdown .dropdown-divider {
  border-top: 1px solid rgba(172, 203, 195, 0.3);
}

.profile-toggle {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: var(--color-sage);
}

.admin-photo {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #accbc3;   /* soft gray border */
  background-color: transparent;
}

.logout-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  color: var(--color-sage);
}

.logout-item:hover {
  background-color: rgba(16, 20, 19, 0.6);
}

.logout-icon {
  font-size: 1.1rem;
  color: var(--color-sage);
}

/* Mobile navigation menu */
.mobile-nav-menu {
  width: 250px;
  max-height: 80vh;
  overflow-y: auto;
  margin: 0;
  background-color: var(--color-dark);
  border: 1px solid rgba(172, 203, 195, 0.3);
}

.mobile-nav-item {
  padding: 0.75rem 1rem;
  white-space: nowrap;
  color: var(--color-sage);
}

.mobile-nav-item:hover {
  background-color: rgba(16, 20, 19, 0.6);
}

.mobile-nav-item.active {
  background-color: var(--color-mint);
  color: var(--color-dark);
}

.mobile-nav-icon {
  font-size: 1.25rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
}

/* Modal styling for dark theme */
.modal-content {
  background-color: var(--color-dark);
  border: 1px solid rgba(172, 203, 195, 0.3);
  color: var(--color-sage);
}

.modal-header {
  background-color: rgba(16, 20, 19, 0.6);
  border-bottom: 1px solid rgba(172, 203, 195, 0.3);
}

.modal-title {
  color: var(--color-sage);
}

.modal-body {
  color: var(--color-sage);
}

.modal-footer {
  border-top: 1px solid rgba(172, 203, 195, 0.3);
}

.header-right-elements .text-primary,
.profile-dropdown .text-primary {
  color: var(--color-sage) !important;
}

/* Don't apply green color to modal titles */
.modal-title.text-primary,
.modal-title {
  color: var(--color-sage) !important;
}

.modal-header .text-primary {
  color: var(--color-sage) !important;
}

/* Prevent .text-primary from affecting form elements - restore original colors */
input.text-primary,
textarea.text-primary,
.form-control.text-primary,
input[type="text"].text-primary,
input[type="email"].text-primary,
input[type="password"].text-primary {
  color: #4d4d4d !important;
  background-color: #fff !important;
}

.text-secondary {
  color: var(--color-sage) !important;
}

/* Ensure all header content is white */
.root-header span:not(.notification-badge),
.root-header button:not(.btn-primary):not(.btn-secondary),
.root-header a,
.root-header div:not(.search-container) {
  color: var(--color-sage) !important;
}

/* Notification icon */
.notification-wrapper svg {
  color: var(--color-sage) !important;
  fill: var(--color-sage) !important;
}

.badge.bg-warning {
  background-color: var(--color-mint) !important;
  color: var(--color-dark) !important;
}

.spinner-border.text-primary {
  color: #1f7c50 !important;
  border-color: #1f7c50 !important;
}

/* Global spinner styling - Dark green */
.spinner-border {
  border-color: #1f7c50;
  border-right-color: transparent;
}

.spinner-border.text-primary {
  color: #1f7c50 !important;
  border-color: #1f7c50 !important;
  border-right-color: transparent !important;
}

/* Responsive adjustments */
@media (max-width: 992px) {
  .search-container {
    max-width: 400px;
  }
}

@media (max-width: 768px) {
  .root-header {
    padding: 0.5rem 0.75rem;
    margin: 0;
  }
  
  .search-container:not(.mobile-visible) {
    display: none;
  }
  
  .mobile-search-toggle {
    display: block;
  }
  
  .header-right-elements {
    gap: 0.5rem;
  }
}

@media (max-width: 576px) {
  .root-header {
    padding: 0.5rem;
    margin: 0;
  }
  
  .language-flag {
    width: 30px;
    height: 20px;
  }
  
  .admin-photo {
    width: 32px;
    height: 32px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE;;qBAEmB;EACnB,uBAAuB;EACvB,kDAAkD;EAClD,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,2BAA2B;AAC7B;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,yDAA6P;EAC7P,4BAA4B;EAC5B,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,mCAAmC;EACnC,kDAAkD;EAClD,qDAAqD;AACvD;;AAEA;EACE,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,2DAA2D;AAC7D;;AAEA;EACE,cAAc;EACd,WAAW;EACX,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,SAAS;AACX;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;AAC1B;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,8CAA8C;EAC9C,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,UAAU;EACV,0CAA0C;EAC1C,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,SAAS;AACX;;AAEA,0BAA0B;AAC1B;EACE,mCAAmC;EACnC,0CAA0C;EAC1C,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uCAAuC;EACvC,wBAAwB;AAC1B;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB,IAAI,qBAAqB;EAClD,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA,2BAA2B;AAC3B;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,mCAAmC;EACnC,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,mCAAmC;EACnC,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA,iCAAiC;AACjC;EACE,mCAAmC;EACnC,0CAA0C;EAC1C,wBAAwB;AAC1B;;AAEA;EACE,uCAAuC;EACvC,iDAAiD;AACnD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,8CAA8C;AAChD;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA,4CAA4C;AAC5C;;EAEE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA,iFAAiF;AACjF;;;;;;EAME,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;AACrC;;AAEA,uCAAuC;AACvC;;;;EAIE,mCAAmC;AACrC;;AAEA,sBAAsB;AACtB;EACE,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,8CAA8C;EAC9C,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA,wCAAwC;AACxC;EACE,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,0CAA0C;AAC5C;;AAEA,2BAA2B;AAC3B;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["/* Qatar-style dark header */\r\n.root-header {\r\n  background: radial-gradient(circle at 0% 0%, rgba(7, 255, 169, 0.18), transparent 55%),\r\n              radial-gradient(circle at 80% 0%, rgba(31, 124, 80, 0.25), transparent 60%),\r\n              #101413;\r\n  padding: 0.75rem 1.5rem;\r\n  border-bottom: 1px solid rgba(172, 203, 195, 0.18);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  flex-wrap: wrap;\r\n  gap: 0.75rem;\r\n  position: relative;\r\n  z-index: 1000;\r\n  color: #e5f6f2;\r\n  backdrop-filter: blur(18px);\r\n}\r\n\r\n/* Sidebar toggle button */\r\n.sidebar-toggle {\r\n  background: none;\r\n  border: none;\r\n  outline: transparent;\r\n  color: #e5f6f2;\r\n  padding: 0.25rem;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: transform 0.3s ease;\r\n}\r\n\r\n.sidebar-toggle:hover {\r\n  transform: scale(1.1);\r\n}\r\n\r\n/* Mobile menu button */\r\n.mobile-menu-button {\r\n  background: none;\r\n  border: none;\r\n  color: #e5f6f2;\r\n  padding: 0.5rem;\r\n}\r\n\r\n.navbar-toggler-icon {\r\n  display: inline-block;\r\n  width: 1.5em;\r\n  height: 1.5em;\r\n  vertical-align: middle;\r\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%280, 0, 0, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\r\n  background-repeat: no-repeat;\r\n  background-position: center;\r\n  background-size: 100%;\r\n}\r\n\r\n/* Search container */\r\n.search-container {\r\n  flex: 1;\r\n  min-width: 200px;\r\n  max-width: 600px;\r\n  margin: 0;\r\n}\r\n\r\n.search-container input {\r\n  color: var(--color-sage) !important;\r\n  background-color: rgba(16, 20, 19, 0.6) !important;\r\n  border: 1px solid rgba(172, 203, 195, 0.3) !important;\r\n}\r\n\r\n.search-container input::placeholder {\r\n  color: var(--color-sage) !important;\r\n  opacity: 0.8;\r\n}\r\n\r\n.search-container input:focus {\r\n  border-color: var(--color-mint) !important;\r\n  box-shadow: 0 0 0 0.2rem rgba(7, 255, 169, 0.25) !important;\r\n}\r\n\r\n.search-container.mobile-visible {\r\n  display: block;\r\n  width: 100%;\r\n  order: 3;\r\n  margin: 0;\r\n}\r\n\r\n.inputSearch {\r\n  position: relative;\r\n  width: 100%;\r\n}\r\n\r\n/* Mobile search toggle */\r\n.mobile-search-toggle {\r\n  background: none;\r\n  border: none;\r\n  color: var(--color-sage);\r\n  margin: 0;\r\n}\r\n\r\n/* Header right elements */\r\n.header-right-elements {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  color: var(--color-sage);\r\n}\r\n\r\n/* Notification */\r\n.notification-wrapper {\r\n  position: relative;\r\n  cursor: pointer;\r\n  padding: 0.5rem;\r\n}\r\n\r\n.notification-badge {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  color: white;\r\n  background-color: var(--color-mint) !important;\r\n  border-radius: 50%;\r\n  width: 18px;\r\n  height: 18px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 0.65rem;\r\n  font-weight: bold;\r\n  background: #07ffa9;\r\n  box-shadow: 0 0 12px rgba(7, 255, 169, 0.9);\r\n}\r\n\r\n/* Language selector */\r\n.lang-switch {\r\n  display: flex;\r\n  align-items: center;\r\n  cursor: pointer;\r\n  color: var(--color-sage) !important;\r\n}\r\n\r\n.lang-switch span {\r\n  color: var(--color-sage) !important;\r\n}\r\n\r\n.language-flag {\r\n  width: 36px;\r\n  height: 24px;\r\n  border-radius: 25%;\r\n  overflow: hidden;\r\n  box-shadow: 0 0 0 1px rgba(172, 203, 195, 0.4);\r\n}\r\n\r\n.language-flag img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n}\r\n\r\n/* Header divider */\r\n.header-divider {\r\n  height: 24px;\r\n  width: 1px;\r\n  background-color: rgba(172, 203, 195, 0.3);\r\n  margin: 0;\r\n}\r\n\r\n/* Profile dropdown */\r\n.profile-dropdown {\r\n  margin: 0;\r\n}\r\n\r\n/* Dropdown menu styling */\r\n.profile-dropdown .dropdown-menu {\r\n  background-color: var(--color-dark);\r\n  border: 1px solid rgba(172, 203, 195, 0.3);\r\n  color: var(--color-sage);\r\n}\r\n\r\n.profile-dropdown .dropdown-item {\r\n  color: var(--color-sage);\r\n}\r\n\r\n.profile-dropdown .dropdown-item:hover {\r\n  background-color: rgba(16, 20, 19, 0.6);\r\n  color: var(--color-sage);\r\n}\r\n\r\n.profile-dropdown .dropdown-divider {\r\n  border-top: 1px solid rgba(172, 203, 195, 0.3);\r\n}\r\n\r\n.profile-toggle {\r\n  display: flex;\r\n  align-items: center;\r\n  cursor: pointer;\r\n  color: var(--color-sage);\r\n}\r\n\r\n.admin-photo {\r\n  width: 38px;\r\n  height: 38px;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border: 1px solid #accbc3;   /* soft gray border */\r\n  background-color: transparent;\r\n}\r\n\r\n.logout-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  padding: 0.5rem 1rem;\r\n  color: var(--color-sage);\r\n}\r\n\r\n.logout-item:hover {\r\n  background-color: rgba(16, 20, 19, 0.6);\r\n}\r\n\r\n.logout-icon {\r\n  font-size: 1.1rem;\r\n  color: var(--color-sage);\r\n}\r\n\r\n/* Mobile navigation menu */\r\n.mobile-nav-menu {\r\n  width: 250px;\r\n  max-height: 80vh;\r\n  overflow-y: auto;\r\n  margin: 0;\r\n  background-color: var(--color-dark);\r\n  border: 1px solid rgba(172, 203, 195, 0.3);\r\n}\r\n\r\n.mobile-nav-item {\r\n  padding: 0.75rem 1rem;\r\n  white-space: nowrap;\r\n  color: var(--color-sage);\r\n}\r\n\r\n.mobile-nav-item:hover {\r\n  background-color: rgba(16, 20, 19, 0.6);\r\n}\r\n\r\n.mobile-nav-item.active {\r\n  background-color: var(--color-mint);\r\n  color: var(--color-dark);\r\n}\r\n\r\n.mobile-nav-icon {\r\n  font-size: 1.25rem;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 24px;\r\n}\r\n\r\n/* Modal styling for dark theme */\r\n.modal-content {\r\n  background-color: var(--color-dark);\r\n  border: 1px solid rgba(172, 203, 195, 0.3);\r\n  color: var(--color-sage);\r\n}\r\n\r\n.modal-header {\r\n  background-color: rgba(16, 20, 19, 0.6);\r\n  border-bottom: 1px solid rgba(172, 203, 195, 0.3);\r\n}\r\n\r\n.modal-title {\r\n  color: var(--color-sage);\r\n}\r\n\r\n.modal-body {\r\n  color: var(--color-sage);\r\n}\r\n\r\n.modal-footer {\r\n  border-top: 1px solid rgba(172, 203, 195, 0.3);\r\n}\r\n\r\n.header-right-elements .text-primary,\r\n.profile-dropdown .text-primary {\r\n  color: var(--color-sage) !important;\r\n}\r\n\r\n/* Don't apply green color to modal titles */\r\n.modal-title.text-primary,\r\n.modal-title {\r\n  color: var(--color-sage) !important;\r\n}\r\n\r\n.modal-header .text-primary {\r\n  color: var(--color-sage) !important;\r\n}\r\n\r\n/* Prevent .text-primary from affecting form elements - restore original colors */\r\ninput.text-primary,\r\ntextarea.text-primary,\r\n.form-control.text-primary,\r\ninput[type=\"text\"].text-primary,\r\ninput[type=\"email\"].text-primary,\r\ninput[type=\"password\"].text-primary {\r\n  color: #4d4d4d !important;\r\n  background-color: #fff !important;\r\n}\r\n\r\n.text-secondary {\r\n  color: var(--color-sage) !important;\r\n}\r\n\r\n/* Ensure all header content is white */\r\n.root-header span:not(.notification-badge),\r\n.root-header button:not(.btn-primary):not(.btn-secondary),\r\n.root-header a,\r\n.root-header div:not(.search-container) {\r\n  color: var(--color-sage) !important;\r\n}\r\n\r\n/* Notification icon */\r\n.notification-wrapper svg {\r\n  color: var(--color-sage) !important;\r\n  fill: var(--color-sage) !important;\r\n}\r\n\r\n.badge.bg-warning {\r\n  background-color: var(--color-mint) !important;\r\n  color: var(--color-dark) !important;\r\n}\r\n\r\n.spinner-border.text-primary {\r\n  color: #1f7c50 !important;\r\n  border-color: #1f7c50 !important;\r\n}\r\n\r\n/* Global spinner styling - Dark green */\r\n.spinner-border {\r\n  border-color: #1f7c50;\r\n  border-right-color: transparent;\r\n}\r\n\r\n.spinner-border.text-primary {\r\n  color: #1f7c50 !important;\r\n  border-color: #1f7c50 !important;\r\n  border-right-color: transparent !important;\r\n}\r\n\r\n/* Responsive adjustments */\r\n@media (max-width: 992px) {\r\n  .search-container {\r\n    max-width: 400px;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .root-header {\r\n    padding: 0.5rem 0.75rem;\r\n    margin: 0;\r\n  }\r\n  \r\n  .search-container:not(.mobile-visible) {\r\n    display: none;\r\n  }\r\n  \r\n  .mobile-search-toggle {\r\n    display: block;\r\n  }\r\n  \r\n  .header-right-elements {\r\n    gap: 0.5rem;\r\n  }\r\n}\r\n\r\n@media (max-width: 576px) {\r\n  .root-header {\r\n    padding: 0.5rem;\r\n    margin: 0;\r\n  }\r\n  \r\n  .language-flag {\r\n    width: 30px;\r\n    height: 20px;\r\n  }\r\n  \r\n  .admin-photo {\r\n    width: 32px;\r\n    height: 32px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
